import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiArrowLeft, FiPhone, FiMapPin, FiInfo, FiShield, FiFileText } = FiIcons;

const ImpressumPage = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 via-white to-indigo-50">
      {/* Header */}
      <header className="bg-white shadow-sm border-b">
        <div className="max-w-4xl mx-auto px-4 py-4 flex items-center">
          <Link 
            to="/" 
            className="flex items-center text-blue-600 hover:text-blue-700 transition-colors mr-4"
          >
            <SafeIcon icon={FiArrowLeft} className="w-5 h-5 mr-2" />
            Zurück
          </Link>
          <h1 className="text-2xl font-bold text-gray-900">Impressum</h1>
        </div>
      </header>

      {/* Main Content */}
      <main className="max-w-4xl mx-auto px-4 py-8">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          className="bg-white rounded-lg shadow-lg p-8 space-y-8"
        >
          {/* Company Information */}
          <section>
            <h2 className="text-xl font-bold text-gray-900 mb-4 flex items-center">
              <SafeIcon icon={FiMapPin} className="w-5 h-5 text-blue-600 mr-2" />
              Unternehmen
            </h2>
            <div className="text-gray-700 leading-relaxed pl-7">
              <p className="font-semibold">Internet Consulting Group Inc.</p>
              <p>304 S. Jones Blvd #3009</p>
              <p>Las Vegas NV 89107</p>
              <p>USA</p>
            </div>
          </section>

          <hr className="border-gray-100" />

          {/* Contact Information */}
          <section>
            <h2 className="text-xl font-bold text-gray-900 mb-4 flex items-center">
              <SafeIcon icon={FiPhone} className="w-5 h-5 text-blue-600 mr-2" />
              Kontakt
            </h2>
            <div className="text-gray-700 leading-relaxed pl-7 space-y-2">
              <p>Telefon: 1-239-645-4696</p>
              <p>E-Mail: <a href="mailto:internetconsultinggroup@gmail.com" className="text-blue-600 hover:underline">internetconsultinggroup@gmail.com</a></p>
            </div>
          </section>

          <hr className="border-gray-100" />

          {/* Responsible Person */}
          <section>
            <h2 className="text-xl font-bold text-gray-900 mb-4 flex items-center">
              <SafeIcon icon={FiInfo} className="w-5 h-5 text-blue-600 mr-2" />
              Verantwortlich für den Inhalt nach § 55 Abs. 2 RStV
            </h2>
            <div className="text-gray-700 leading-relaxed pl-7">
              <p className="font-semibold">Internet Consulting Group Inc.</p>
              <p>304 S. Jones Blvd #3009</p>
              <p>Las Vegas NV 89107</p>
              <p>USA</p>
            </div>
          </section>

          <hr className="border-gray-100" />

          {/* Liability Disclaimer */}
          <section>
            <h2 className="text-2xl font-bold text-gray-900 mb-6 flex items-center">
              <SafeIcon icon={FiShield} className="w-6 h-6 text-blue-600 mr-2" />
              Haftungsausschluss
            </h2>
            
            <div className="space-y-6 pl-1">
              <div>
                <h3 className="text-lg font-semibold text-gray-900 mb-2">Haftung für Inhalte</h3>
                <p className="text-gray-700 text-justify leading-relaxed">
                  Als Diensteanbieter sind wir gemäß § 7 Abs.1 TMG für eigene Inhalte auf diesen Seiten nach den allgemeinen Gesetzen verantwortlich. Nach §§ 8 bis 10 TMG sind wir als Diensteanbieter jedoch nicht verpflichtet, übermittelte oder gespeicherte fremde Informationen zu überwachen oder nach Umständen zu forschen, die auf eine rechtswidrige Tätigkeit hinweisen. Verpflichtungen zur Entfernung oder Sperrung der Nutzung von Informationen nach den allgemeinen Gesetzen bleiben hiervon unberührt. Eine diesbezügliche Haftung ist jedoch erst ab dem Zeitpunkt der Kenntnis einer konkreten Rechtsverletzung möglich. Bei Bekanntwerden von entsprechenden Rechtsverletzungen werden wir diese Inhalte umgehend entfernen.
                </p>
              </div>

              <div>
                <h3 className="text-lg font-semibold text-gray-900 mb-2">Haftung für Links</h3>
                <p className="text-gray-700 text-justify leading-relaxed">
                  Unser Angebot enthält Links zu externen Websites Dritter, auf deren Inhalte wir keinen Einfluss haben. Deshalb können wir für diese fremden Inhalte auch keine Gewähr übernehmen. Für die Inhalte der verlinkten Seiten ist stets der jeweilige Anbieter oder Betreiber der Seiten verantwortlich. Die verlinkten Seiten wurden zum Zeitpunkt der Verlinkung auf mögliche Rechtsverstöße überprüft. Rechtswidrige Inhalte waren zum Zeitpunkt der Verlinkung nicht erkennbar. Eine permanente inhaltliche Kontrolle der verlinkten Seiten ist jedoch ohne konkrete Anhaltspunkte einer Rechtsverletzung nicht zumutbar. Bei Bekanntwerden von Rechtsverletzungen werden wir derartige Links umgehend entfernen.
                </p>
              </div>
            </div>
          </section>

          <hr className="border-gray-100" />

          {/* Copyright */}
          <section>
            <h2 className="text-xl font-bold text-gray-900 mb-4 flex items-center">
              <SafeIcon icon={FiFileText} className="w-5 h-5 text-blue-600 mr-2" />
              Urheberrecht
            </h2>
            <div className="text-gray-700 text-justify leading-relaxed pl-7">
              <p>
                Die durch die Seitenbetreiber erstellten Inhalte und Werke auf diesen Seiten unterliegen dem deutschen Urheberrecht. Die Vervielfältigung, Bearbeitung, Verbreitung und jede Art der Verwertung außerhalb der Grenzen des Urheberrechtes bedürfen der schriftlichen Zustimmung des jeweiligen Autors bzw. Erstellers. Downloads und Kopien dieser Seite sind nur für den privaten, nicht kommerziellen Gebrauch gestattet. Soweit die Inhalte auf dieser Seite nicht vom Betreiber erstellt wurden, werden die Urheberrechte Dritter beachtet. Insbesondere werden Inhalte Dritter als solche gekennzeichnet. Sollten Sie trotzdem auf eine Urheberrechtsverletzung aufmerksam werden, bitten wir um einen entsprechenden Hinweis. Bei Bekanntwerden von Rechtsverletzungen werden wir derartige Inhalte umgehend entfernen.
              </p>
            </div>
          </section>

          {/* Footer Navigation */}
          <div className="pt-8 border-t border-gray-200 text-center">
            <Link 
              to="/" 
              className="inline-flex items-center text-blue-600 hover:text-blue-800 font-medium transition-colors"
            >
               Zurück zur Startseite
            </Link>
          </div>

        </motion.div>
      </main>
    </div>
  );
};

export default ImpressumPage;